export default __webpack_public_path__ + "static/media/success.d7c70069.svg";